
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import image404 from './images/404.svg?external'
import image500 from './images/500.svg?external'

export default class EmptyView extends React.Component {
  static propTypes = {
    status: PropTypes.number
  }

  static defaultProps = {
    status: 404
  }

  render() {
    return (
      <div className='not-found-view'>
        <div className='not-found-view_image'>
          <img src={this.props.status === 404 ? image404 : image500} width='320' height='312' />
        </div>
        <div className='not-found-view_title'>
          Ooops!
        </div>
        <div className='not-found-view_description'>
          {
            this.props.status === 404
              ? `You've reached a page that doesn't exist.`
              : `Something went wrong, we're working on the issue right now.`
          }
        </div>
        <div className='not-found-view_text'>
          Please try again or contact <a href='mailto:marketing-cloud@sportradar.com'>marketing-cloud@sportradar.com</a>.
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/NotFoundView/index.js